import { jsx as _jsx } from "react/jsx-runtime";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useCallback, useMemo } from 'react';
import { Button, useLocalizeMessage, Icon } from 'libs.nucleus';
import { ImageUpload as GenericImageUpload } from '../../image_uploader/image_upload';
import { useImagesContext } from '../contexts/images_context';
import { FormatterWrapper } from '../formatters/formatter_wrapper';
import { INSERT_IMAGE_COMMAND } from '../plugins/images_plugin';
/**
 * Component for uploading an image to the rich content editor. Should be used as achild of FormatBar. Does not allow
 * more than one image to be uploaded.
 */
export const ImageUpload = ({ onUpload, uploader }) => {
    const t = useLocalizeMessage();
    const [editor] = useLexicalComposerContext();
    const { images } = useImagesContext();
    const handleUpload = useCallback((imageUrl) => {
        const payload = {
            src: imageUrl,
            alt: '',
            title: '',
        };
        editor.dispatchCommand(INSERT_IMAGE_COMMAND, payload);
        onUpload?.(imageUrl);
    }, [onUpload]);
    const uploaderErrorMessage = useMemo(() => {
        return Object.keys(images).length > 0
            ? t('An image already exists in this section. Please remove the image from the editor to replace it.')
            : '';
    }, [images]);
    return (_jsx(GenericImageUpload, { onUpload: handleUpload, uploader: uploader, container: FormatterWrapper, openModalButton: OpenModalButton, disabled: Object.keys(images).length > 0, uploaderErrorMessage: uploaderErrorMessage }));
};
const OpenModalButton = ({ onClick }) => {
    const t = useLocalizeMessage();
    return (_jsx(Button, { label: t('Upload image'), variant: 'transparent', type: 'button', size: 'full', content: _jsx(Icon, { name: 'image', size: 20, color: 'black' }), onClick: onClick }));
};
